import { z } from 'zod'

export const ADMINDESKTOPAGENTSGETGRANTS_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsGetGrantsResponseSchema = z.unknown()
export type AdminDesktopAgentsGetGrantsResponse = z.infer<typeof adminDesktopAgentsGetGrantsResponseSchema>
